import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { exchangeSession } from "../lib/auth";

// Handles the OAuth return: exchanges the one-time session_id for a session cookie.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      setError(true);
      return;
    }
    exchangeSession(sessionId)
      .then((user) => navigate("/", { replace: true, state: { user } }))
      .catch(() => setError(true));
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-canvas text-ink font-sans flex items-center justify-center" data-testid="auth-callback">
      {error ? (
        <div className="text-center max-w-sm px-6">
          <p className="font-display text-2xl font-semibold">Sign-in didn't complete.</p>
          <p className="mt-3 text-sm text-body">
            <Link to="/" className="text-teal link-underline" data-testid="auth-callback-retry">
              Try again
            </Link>
          </p>
        </div>
      ) : (
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-faint">Signing you in…</p>
      )}
    </div>
  );
}
